<ng-container *ngIf="notifications$ | async"></ng-container>
<ng-container *ngIf="notifyConnection$ | async"></ng-container>
<ng-container *ngIf="markAsRead$ | async"></ng-container>

<div fxLayout="column" fxFlex fusePerfectScrollbar>
  <div class="h3 secondary-text p-2" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
    <div i18n>Уведомления</div>
    <button mat-icon-button i18n-matTooltip matTooltip="Отметить все прочитанным" (click)="markAllAsRead()">
      <mat-icon>mark_email_read</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div *ngFor="let notification of notifications">
    <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="8px" class="py-4 px-4 notification">
      <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex>
        <div class="title mat-body-2" [innerHTML]="notification.title"></div>
        <div class="content mat-body" [innerHTML]="notification.content"></div>
        <div class="secondary-text mt-2 mat-caption">{{ notification.creationDate | date : 'dd.MM.yyyy HH:mm' }}</div>
      </div>
      <div>
        <button
          class="h-6 w-6 mark-as-read"
          mat-icon-button
          i18n-matTooltip
          matTooltip="Отметить прочитанным"
          matTooltipPosition="left"
          [disabled]="markAsReadProcess || notification.read"
          (click)="markAsRead([notification.id])">
          <mat-icon
            [ngClass]="{
              primary: !(markAsReadProcess || notification.read),
              'grey-400': markAsReadProcess || notification.read
            }"
            class="s-8 rounded-full"></mat-icon>
        </button>
      </div>
    </div>

    <mat-divider> </mat-divider>
  </div>
</div>
